export const defaultParameters = ["pH", "COD", "TSS", "NH3N", "Flowrate", "Temperature", "Depth Level"]